import { route } from 'quasar/wrappers';
import {
  RouteRecordRaw,
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';

import plannerGuards from './planner/guards'
import whiteLabelGuards from './whitelabel/guards'
import bookingGuards from './booking/guards'
import adminGuards from './admin/guards'

import plannerRoutes from './planner/routes';
import whiteLabelRoutes from './whitelabel/routes'
import bookingRoutes from './booking/routes'
import adminRoutes from './admin/routes'

let routes: RouteRecordRaw[]
// Load routes depending on the project and business type
if (process.env.BUSINESS_ID) {
  routes = whiteLabelRoutes
} else if (process.env.PROJECT === 'booking' || process.env.PROJECT === 'dev.booking') {
  routes = bookingRoutes
} else if (process.env.PROJECT === 'admin' || process.env.PROJECT === 'dev.admin') {
  routes = adminRoutes
} else {
  routes = plannerRoutes
}

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ?
    createWebHistory :
    createWebHashHistory);

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach(
    process.env.BUSINESS_ID ?
    whiteLabelGuards :
    process.env.PROJECT === 'booking' || process.env.PROJECT === 'dev.booking' ?
    bookingGuards :
    process.env.PROJECT === 'admin' || process.env.PROJECT === 'dev.admin' ?
    adminGuards :
    plannerGuards
  )

  return Router;
});
